import Controller from "@ember/controller"

export default class UserSessionsController extends Controller {
  queryParams = ["sessionId"]
}
